
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      relogin: false,
      viewPopup: null,
      state: 'start',
      domain: this.$root.getDomain(),
      showDomainsList: this.$root.canChangeDomain(),
      showDomainsApi: this.$root.canChangeApi(),
      domainsList: [
        {
          title: 'fanbattle.ru',
          value: 'fanbattle.ru',
          selected: this.$root.getSelectedDomain() == 'fanbattle.ru'
        },
        {
          title: 'fanbattle.app',
          value: 'fanbattle.app',
          selected: this.$root.getSelectedDomain() == 'fanbattle.app'
        },
        {
          title: 'fanbattle.mobi',
          value: 'fanbattle.mobi',
          selected: this.$root.getSelectedDomain() == 'fanbattle.mobi'
        }
      ],
      apiList: [
        {
          title: 'Api1',
          value: 'https://api.fanbattle.net/',
          selected: false
        },
        {
          title: 'Api2',
          value: 'https://dev.api.fanbattle.ru/',
          selected: true
        }
      ]
    };
  },
  methods: {
    changeDomain: function (e) {
      var domain = this.$(e.target).val();
      this.$root.setSelectedDomain(domain);
    },
    changeApi(e) {
      let api = this.$(e.target).val();
      this.$root.setSelectedApi(api);
    },
    emailEl: function () {
      return this.$el.find('#login-input-email');
    },
    passwordEl: function () {
      return this.$el.find('#login-input-password');
    },
    nicknameEl: function () {
      return this.$el.find('#login-input-nickname');
    },
    remember: function () {
      this.$router.navigate('/auth/remember/?email=' + this.emailEl().val());
    },
    setStartState: function () {
      var self = this;
      this.state = 'start';
      this.udpateLoginButtonEnabled();
      this.$el.find('#block-restore').show();
      this.$el.find('#list-item-password').animate({ height: 0.000001 }, { duration: 400 });
      this.$el.find('#list-item-nickname').animate({ height: 0.000001 }, { duration: 400 });
    },
    setLoginState: function () {
      var self = this;
      this.state = 'login';
      this.udpateLoginButtonEnabled();
      this.$el.find('#block-restore').show();
      this.$el.find('#list-item-password').css('height', '1px');
      this.$el.find('#list-item-password').animate({ height: 72 }, { duration: 400 });
      this.$el.find('#list-item-nickname').animate({ height: 0.000001 }, { duration: 400 });
    },
    setRegistrationState: function () {
      var self = this;
      this.state = 'registration';
      this.udpateLoginButtonEnabled();
      this.$el.find('#block-restore').hide();
      this.$el.find('#list-item-password').animate({ height: 72 }, { duration: 400 });
      this.$el.find('#list-item-nickname').animate({ height: 86 }, { duration: 400 });
    },
    changeEmail: function (e) {
      if (this.state != 'start') {
        this.setStartState();
      } else {
        this.udpateLoginButtonEnabled();
      }
    },
    changePassword: function () {
      this.udpateLoginButtonEnabled();
    },
    changeNickname: function () {
      this.udpateLoginButtonEnabled();
    },
    setLoginButtonEnabled: function (enabled) {
      if (enabled) {
        this.$el.find('#button-login').removeClass('disabled');
      } else {
        this.$el.find('#button-login').addClass('disabled');
      }
    },
    setLoginButtonLoading: function (loading) {
      if (loading) {
        this.$el.find('#button-login').addClass('disabled').html('<div class="preloader color-white">' + this.$app.utils.iosPreloaderContent + '</div>');
      } else {
        this.$el.find('#button-login').removeClass('disabled').html('Войти');
      }
    },
    setRegistrationButtonLoading: function (loading) {
      if (loading) {
        this.$el.find('#button-registration').addClass('disabled').html('<div class="preloader color-white">' + this.$app.utils.iosPreloaderContent + '</div>');
      } else {
        this.$el.find('#button-registration').removeClass('disabled').html('Войти как гость');
      }
    },
    udpateLoginButtonEnabled: function () {
      if (this.state == 'start') {
        this.setLoginButtonEnabled(true);
      }
      if (this.state == 'login') {
        this.setLoginButtonEnabled(true);
      }
      if (this.state == 'registration') {
        this.setLoginButtonEnabled(true);
      }
    },
    next: function () {
      if (this.state == 'start') {
        this.checkEmail();
      }
      if (this.state == 'login') {
        this.login();
      }
    },
    checkEmail: function () {
      var self = this;
      this.setLoginButtonLoading(true);
      this.$root.api('app/check', { email: this.emailEl().val() }, 'POST', function (data, status, xhr) {
        self.setLoginButtonLoading(false);
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message);
        }
        if (data.status == 'ok') {
          if (data.method == 'login') {
            self.setLoginState();
          }
          if (data.method == 'registration') {
            self.$app.dialog.alert('Пользователь с таким email не зарегистрирован');
          }
        }
      }, false, {
        callback: function () {
          self.setLoginButtonLoading(false);
        }
      });
    },
    login: function () {
      var self = this;
      var data = {
        email: this.emailEl().val(),
        password: this.passwordEl().val(),
        domain: this.$root.getDomain()
      };
      self.setLoginButtonLoading(true);
      this.$root.api('app/login', data, 'POST', function (data, status, xhr) {
        self.setLoginButtonLoading(false);
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message);
        }
        if (data.status == 'ok') {
          self.$app.popup.close();
          self.$root.setKey('guest_id', null);
          self.$root.login(data.token, data.login_parameter);
        }
      }, false, {
        callback: function () {
          self.setLoginButtonLoading(false);
        }
      });
      return;
    },
    registration: function () {
      var self = this;
      var data = {
        name: this.nicknameEl().val(),
        email: this.emailEl().val(),
        password: this.passwordEl().val(),
        password_confirmation: this.passwordEl().val(),
        domain: this.$root.getDomain()
      };
      if (this.$root.getKey('guest_id') !== null) {
        data['guest_id'] = this.$root.getKey('guest_id');
      }
      self.setLoginButtonLoading(true);
      this.$root.api('app/registration', data, 'POST', function (data, status, xhr) {
        self.setLoginButtonLoading(false);
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message, 'Ошибка');
        }
        if (data.status == 'ok') {
          self.$root.setKey('registration_time', new Date().getTime());
          self.$app.popup.close();
          self.$root.setKey('guest_id', null);
          self.$root.login(data.token, data.login_parameter);
        }
      }, false, {
        callback: function () {
          self.setLoginButtonLoading(false);
        }
      });
    },
    registrationAsGuest: function () {
      var self = this;
      var data = { domain: this.$root.getDomain() };
      if (this.$root.getKey('guest_id') !== null) {
        data['guest_id'] = this.$root.getKey('guest_id');
      }
      self.setRegistrationButtonLoading(true);
      this.$root.api('app/guest', data, 'POST', function (data, status, xhr) {
        self.setRegistrationButtonLoading(false);
        if (data.status == 'error') {
          self.$app.dialog.alert(data.message, 'Ошибка');
        }
        if (data.status == 'ok') {
          self.$app.popup.close();
          self.$root.setKey('guest_id', data.guest_id);
          self.$root.login(data.token, data.login_parameter);
        }
      }, false, {
        callback: function () {
          self.setRegistrationButtonLoading(false);
        }
      });
    },
    authFb: function () {
      this.$app.methods.authFb();
    },
    authVk: function () {
      this.$app.methods.authVk();
    },
    openRegistrationPage() {
      this.$router.navigate({ name: 'auth.registration' });
    }
  },
  on: {
    pageInit: function () {
      var self = this;
      if (window.webkit) {
        if (typeof window.logout == 'undefined') {
          if (self.$app.methods.getTypeApp() == 'olimp') {
            window.webkit.messageHandlers.iosListener.postMessage('refresh');
            window.logout = 1;
            self.$router.navigate({ name: 'something-wrong' });
            return false;
          }
          window.webkit.messageHandlers.iosListener.postMessage('logout');
          window.logout = 1;
        }
        setTimeout(() => {
          window.logout = 'undefined';
        }, 1000);
      }
      self.state = 'start';
    }
  },
  id: '4928e12720',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page">\n        <div class="navbar">\n            <div class="navbar-inner navbar-auth">\n            </div>\n        </div>\n\n        <div class="page-content bg-color-white">\n            <div class="block text-align-center no-margin-top no-margin-bottom">\n                <div class="login-logo" style="width: 148px;"></div>\n            </div>\n            <div class="list list-login-input no-margin-top">\n                <li class="item-content item-input">\n                    <div class="item-inner">\n                        <div class="item-title item-floating-label">Email</div>\n                        <div class="item-input-wrap">\n                            <input id="login-input-email" name="email" type="text" @input="changeEmail" placeholder="">\n                            <span class="input-clear-button"></span>\n                        </div>\n                    </div>\n                </li>\n\n                <li class="item-content item-input" id="list-item-password"\n                    style="min-height: 0;height: 0.000001px;overflow: hidden;">\n                    <div class="item-inner">\n                        <div class="item-title item-floating-label">Пароль</div>\n                        <div class="item-input-wrap">\n                            <input id="login-input-password" name="password" type="password" @input="changePassword">\n                            <span class="input-clear-button"></span>\n                        </div>\n                    </div>\n                </li>\n\n                <li class="item-content item-input item-input-with-info" id="list-item-nickname"\n                    style="min-height: 0;height: 0.000001px;overflow: hidden;">\n                    <div class="item-inner">\n                        <div class="item-title item-floating-label">Никнейм</div>\n                        <div class="item-input-wrap">\n                            <input id="login-input-nickname" name="nickname" type="text" @input="changeNickname">\n                            <span class="input-clear-button"></span>\n                            <div class="item-input-info">Минимум 4 символа</div>\n                        </div>\n                    </div>\n                </li>\n\n                <li class="item-content item-input"\n                    style="visibility: hidden;min-height:30px;height: 0px; overflow: hidden;"></li>\n\n                </ul>\n            </div>\n\n            <div class="block">\n                <button class="button button-fill disabled" id="button-login" @click="next">Войти</button>\n            </div>\n\n            <div class="block text-align-center" id="block-restore">\n                <a href="#" @click="remember" class="link" id="link-restore">Забыли пароль?</a>\n            </div>\n\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.authButtons, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block block-sn">\n                <div class="segmented">\n                    <button class="button button-fill" id="button-fb" @click="authFb"><i\n                        class="icon icon-button-fb"></i> Facebook\n                    </button>\n                    <button class="button button-fill" id="button-vk" @click="authVk"><i\n                        class="icon icon-button-vk"></i> ВКонтакте\n                    </button>\n                </div>\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="block" id="block-menu">\n                <p class="row">\n                    <button class="col button button-large button-fill green-fb" @click="openRegistrationPage">\n                        Регистрация\n                    </button>\n                    <button class="col button button-fill" id="button-registration" @click="registrationAsGuest">Войти\n                        как гость\n                    </button>\n                </p>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  style: `
    :root {
        --f7-navbar-bg-color: white;
        --f7-navbar-border-color: white;
        --f7-navbar-link-color: #445058;
        --f7-navbar-text-color: #445058;
        --f7-floating-label-scale: calc(12 / 12);
    }

    .green-fb {
        background-color: #32BF61 !important;
    }

    .green-fb:active {
        background-color: #32c061de !important;
    }

    .item-floating-label {
        color: #a9a9a9 !important;
    }

    .login-input-label {
        font-size: 13px !important;
    }

    .block-sn {
        margin-top: 70px;
    }

    .list-login-input {
        --f7-block-font-size: 18px;
        --f7-block-text-color: #445058;
        --f7-list-bg-color: white;
        --f7-list-border-color: white;
        --f7-label-text-color: #007AFF;
    }

    #link-restore {
        font-size: 14px;
        color: #007AFF;
    }

    #block-logo {
        margin-top: 0px;
    }

    #block-menu {
        margin-top: 101px;
        width: 100%;
    }

    #button-fb {
        background-color: #4267B2;
        height: 46px;
    }

    #button-vk {
        background-color: #325B87;
        height: 46px;
    }

    #button-login {
        background-color: #007AFF;
        height: 44px;
        font-size: 17px;
    }

    #button-registration {
        height: 44px;
        font-size: 17px;
        background-color: #AAADB3;
    }

    #login-input-email {
        font-size: 17px;
        padding-right: 20px;
    }

    #login-input-password {
        font-size: 17px;
        padding-right: 20px;
    }

    #login-input-nickname {
        font-size: 17px;
        padding-right: 20px;
    }

    a {
        font-size: 16px;
    }

    .toolbar {
        display: none;
    }

    @media only screen and (max-width: 340px) {
        .row .col {
            --f7-cols-per-row: 1 !important;
        }

        .row .col + .col {
            margin-top: 5px;
        }

    }

`,
  styleScoped: false
};
    